"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromptModal = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _uxUtils = require("@site/ux-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ExpressCartModal = _interopRequireDefault(require("./ExpressCartModal"));
var _DomainRecommendationsModal = require("./DomainRecommendationsModal");
var _constants = require("../../constants");
const DEFAULT_BASKET_ID = 'default';
const PromptModal = ({
  data = {},
  params = {}
}) => {
  const {
    addToCardData,
    addToCartStatus,
    handleExpressCartClose,
    handleExpressCartBack,
    handleDomainsModalBack,
    handleDomainsModalClose,
    handleExpressCartError,
    handlePurchaseDomain,
    purchasedDomains,
    prompt
  } = data;
  const {
    appName = _constants.APP_NAME
  } = params;
  const deviceType = (0, _uxUtils.useDeviceType)();
  const {
    isMobile
  } = deviceType;
  if (addToCardData?.basketId && addToCardData.basketId !== DEFAULT_BASKET_ID && addToCartStatus === _constants.REQUEST_STATUS.SUCCESS) {
    const {
      basketId
    } = addToCardData;
    return /*#__PURE__*/_react.default.createElement(_ExpressCartModal.default, {
      appKey: appName,
      basketId: basketId,
      closeModal: handleExpressCartClose,
      onBack: handleExpressCartBack,
      onError: handleExpressCartError
    });
  }
  if (prompt) {
    return /*#__PURE__*/_react.default.createElement(_DomainRecommendationsModal.DomainRecommendationsModal, (0, _extends2.default)({}, prompt, {
      isAddingToCart: addToCartStatus === _constants.REQUEST_STATUS.LOADING,
      onAddToCart: domainData => handlePurchaseDomain(domainData, 'domain_ai_suggestions_modal'),
      onClose: handleDomainsModalClose,
      onBack: handleDomainsModalBack,
      isMobileView: isMobile,
      getIsDomainPurchased: domainName => Boolean(purchasedDomains[domainName]),
      params: params
    }));
  }
  return null;
};
exports.PromptModal = PromptModal;
PromptModal.propTypes = {
  data: _propTypes.default.object,
  params: _propTypes.default.object
};